module.exports = __webpack_public_path__ + "img/advantage1@2x.6ef1ef2b.png";